import script from "./VideoUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoUpload.vue?vue&type=script&setup=true&lang=js"

import "./VideoUpload.vue?vue&type=style&index=0&id=538f3ddd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538f3ddd"]])

export default __exports__